import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import SkillsTree from './components/SkillsTree';
import SkillDesc from './components/SkillDesc';
import SkillAssign from './components/SkillAssign';
import  StudentLogin  from './components/StudentLogin';
import { Dashboard } from './components/Dashboard';
import { BusinessAnalytics } from './components/BusinessAnalytics';
import SubjectsAndTopics from './components/SubjectsAndTopics';
import GraphExplorerWithLayout from './components/GraphExplorerWithLayout';
import ProtectedRoute from './components/controls/ProtectedRoute';
import { SkillsCacheProvider } from './context/skillsCacheContext';
import { useAuth } from './hooks/useAuth';
import SkillsMapLanding from './pages/SkillsMapLanding';

const AppRoutes = () => {
  const location = useLocation();
  const { token } = useAuth();
  React.useEffect(() => {
    console.log('[AppRoutes] Current location:', location.pathname);
  }, [location]);
return (
    <SkillsCacheProvider token={token ?? ''}>
      <Routes>
          <Route path="/" element={<SkillsMapLanding />} />
          <Route path="/login" element={<StudentLogin />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/explore" element={<GraphExplorerWithLayout />} />
          <Route path="/graph" element={<GraphExplorerWithLayout />} />
          <Route path="/skills-tree" element={<ProtectedRoute><SkillsTree /></ProtectedRoute>} />
          <Route path="/skill" element={<ProtectedRoute><SkillDesc /></ProtectedRoute>} />
          <Route path="/skill/:skillID" element={<ProtectedRoute><SkillDesc /></ProtectedRoute>} />
          <Route path="/assign-skill" element={<ProtectedRoute><SkillAssign /></ProtectedRoute>} />
          <Route path="/subjects-and-topics" element={<ProtectedRoute><SubjectsAndTopics /></ProtectedRoute>} />
          <Route path="/business-analytics" element={<ProtectedRoute><BusinessAnalytics /></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </SkillsCacheProvider>
);
};

export default AppRoutes;